// Logica pura per il tracciamento dello scroll-depth (evento GA4 `scroll`).
// Le soglie e le percentuali sono qui, isolate da DOM e GTM, per essere testabili.

// Soglie di scroll (percentuale di pagina scrollata) come da specifica evento `scroll`.
export const SCROLL_THRESHOLDS = [25, 50, 75, 100]

// Percentuale di pagina scrollata: 100 quando il fondo del viewport raggiunge
// il fondo del documento. Se la pagina non è scrollabile, si considera 100.
export const getScrollPercent = (
  scrollTop: number,
  viewportHeight: number,
  documentHeight: number
): number => {
  const scrollable = documentHeight - viewportHeight

  if (scrollable <= 0) {
    return 100
  }

  const percent = Math.round((scrollTop / scrollable) * 100)

  return Math.min(100, Math.max(0, percent))
}

// Restituisce le soglie raggiunte dalla percentuale corrente e non ancora inviate.
export const getNewlyCrossedThresholds = (
  percent: number,
  thresholds: number[],
  fired: number[]
): number[] => thresholds.filter((threshold) => percent >= threshold && !fired.includes(threshold))
